import {FC} from 'react';
import {ErrorBoundary, FallbackProps} from 'react-error-boundary';
import {AppErrorPage} from '../component/layout/AppErrorPage';
import {useApi} from './Auth';
import {sendLog} from './log';

const ErrorFallback: FC<FallbackProps> = (props) => {
  const {error, resetErrorBoundary} = props;
  return <AppErrorPage onOk={resetErrorBoundary} />;
};

export const AppErrorBoundary: FC<{children: React.ReactNode}> = (props) => {
  const api = useApi();

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={async (error, info) => {
        await sendLog(api, {
          errCode: 'js.apperrorboundary',
          errText: JSON.stringify(error),
          errObj: JSON.stringify({
            error,
            info,
            componentStack: info.componentStack,
          }),
        });
      }}
    >
      {props.children}
    </ErrorBoundary>
  );
};
